import React, { useState } from 'react';
import axios from 'axios';

const API_BASE_URL = process.env.NODE_ENV === 'production' 
  ? 'https://tickets.fortunachile.cl:5000'
  : 'http://localhost:5000';

const ControlPanel = ({ currentTicket, onChangeTicket, ticketLimits }) => {
  const [customNumber, setCustomNumber] = useState('');
  const [showInput, setShowInput] = useState(false);
  const [loading, setLoading] = useState(false);

  const setSpecificNumber = async (targetNumber) => {
    setLoading(true);
    try {
      const response = await axios.post(`${API_BASE_URL}/api/set-number`, {
        targetNumber: parseInt(targetNumber)
      });
      
      console.log('Número cambiado exitosamente:', response.data);
      return true;
    } catch (error) {
      console.error('Error cambiando número:', error);
      alert(error.response?.data?.error || 'Error cambiando número');
      return false;
    } finally {
      setLoading(false);
    }
  };

  const handleCustomReset = async () => {
    const number = parseInt(customNumber);
    
    if (isNaN(number)) {
      alert('Por favor ingresa un número válido');
      return;
    }

    if (number < ticketLimits.min || number > ticketLimits.max) {
      alert(`El número debe estar entre ${ticketLimits.min} y ${ticketLimits.max}`);
      return;
    }

    if (window.confirm(`¿Estás seguro de que quieres cambiar el número a ${number}?`)) {
      const success = await setSpecificNumber(number);
      if (success) {
        setCustomNumber('');
        setShowInput(false);
      }
    }
  };

  const handleQuickSet = async (number) => {
    if (window.confirm(`¿Estás seguro de que quieres cambiar el número a ${number}?`)) {
      await setSpecificNumber(number);
    }
  };

  return (
    <div className="control-panel">
      <h2>Control de Tickets</h2>
      <div className="current-number">{currentTicket}</div>
      
      <div className="buttons">
        <button className="up-btn" onClick={() => onChangeTicket('increment')}>
          Siguiente ↑
        </button>
        <button className="down-btn" onClick={() => onChangeTicket('decrement')}>
          Anterior ↓
        </button>
      </div>

      <div className="custom-control-section">
        <h3>Configuración Personalizada</h3>
        
        {showInput ? (
          <div className="custom-input-group">
            <input
              type="number"
              value={customNumber}
              onChange={(e) => setCustomNumber(e.target.value.replace(/[^0-9]/g, ''))}
              placeholder={`Entre ${ticketLimits.min} y ${ticketLimits.max}`}
              min={ticketLimits.min}
              max={ticketLimits.max}
              className="number-input"
              disabled={loading}
            />
            <div className="input-buttons">
              <button 
                className="confirm-btn"
                onClick={handleCustomReset}
                disabled={!customNumber || loading}
              >
                {loading ? '⏳' : '✅'} Aplicar
              </button>
              <button 
                className="cancel-btn"
                onClick={() => {
                  setShowInput(false);
                  setCustomNumber('');
                }}
                disabled={loading}
              >
                ❌ Cancelar
              </button>
            </div>
          </div>
        ) : (
          <button 
            className="set-custom-btn"
            onClick={() => setShowInput(true)}
            disabled={loading}
          >
            📝 Establecer Número Personalizado
          </button>
        )}

      </div>

      <div className="limits-info-panel">
        <p>Al llegar a {ticketLimits.max}, el siguiente número será {ticketLimits.min}</p>
        <p>Al llegar a {ticketLimits.min}, el anterior número será {ticketLimits.max}</p>
      </div>

      {loading && (
        <div className="loading-overlay">
          <div className="loading-spinner">⏳ Cambiando número...</div>
        </div>
      )}
    </div>
  );
};

export default ControlPanel;